import React from 'react';

import InstagramIcon from '../icons/Instagram.svg';
import FacebookIcon from '../icons/Facebook.svg';

import multiplanLogo from '../modules/seventhModule/images/logo-multiplan.png';

const Footer = () => (
  <footer className="bg-[#efeae7] px-5 py-6 border-t border-[#e0e0e0]">
    <div className="max-w-[1280px] mx-auto flex flex-row justify-between items-center relative">
      <div className="flex items-center gap-4 md:gap-4 flex-row z-10 relative">
        <img src={multiplanLogo} alt="Multiplan" className="h-7 md:h-7" />
        <div className="flex gap-4">
          <a href="https://www.instagram.com/meumulti/" target="_blank" rel="noopener noreferrer" className="flex">
            <img src={InstagramIcon} alt="Instagram" className="w-7 h-7 cursor-pointer text-[#605757]" />
          </a>
          <a href="https://www.facebook.com/meumulti/" target="_blank" rel="noopener noreferrer" className="flex">
            <img src={FacebookIcon} alt="Facebook" className="w-7 h-7 cursor-pointer text-[#605757]" />
          </a>
        </div>
      </div>
      <div className="text-center static md:absolute right-0 left-0 mx-auto">
        <a
          href="/#/politica-de-privacidade"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#605757] text-xs hover:underline"
        >
          Política de Privacidade
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
